import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '../components/ui/Spinner';
import { useI18nTranslation } from '../lib/use-i18n-translation';
import { useAuth } from './AuthContext';
import { CHANGE_PASSWORD_PATH } from './landing-path';

/**
 * Signed-in users only. A user who must change their password is held on `/change-password` until they do —
 * the API enforces the same rule (403 everywhere else), this just keeps the UI from asking.
 */
export const ProtectedRoute = () => {
  const { user, isAuthenticated, isBootstrapping } = useAuth();
  const location = useLocation();
  const { t } = useI18nTranslation();

  if (isBootstrapping) {
    return (
      <div className="flex h-full items-center justify-center gap-2 text-muted-foreground">
        <Spinner label={t('app.loading')} />
        <span className="text-sm">{t('app.loading')}</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (user?.mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return (
      <Navigate
        to={CHANGE_PASSWORD_PATH}
        replace
      />
    );
  }

  return <Outlet />;
};
